"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToTargetLanguageCode = exports.targetLanguageCodeMapping = exports.isPropertyTranslatedByAi = void 0;
const language_code_util_1 = require("./language-code.util");
const isPropertyTranslatedByAi = (propertyName, stencilName, assetSpaces) => {
    const neverTranslatedProperties = [
        'legal-disclaimer',
        'playground-project',
        'results-table-column-name',
    ];
    if (neverTranslatedProperties.includes(propertyName)) {
        return false;
    }
    const propertyExceptionsForRBR = [
        'author',
        'credits',
        'website',
    ];
    if (propertyExceptionsForRBR.includes(propertyName) && assetSpaces?.includes('redbull-racing')) {
        return false;
    }
    const movingImagesStencils = [
        'episode-video',
        'film',
        'live-video',
        'recap-video',
        'show',
        'season',
        'trailer-video',
        'video',
        'video-vr-360',
    ];
    if (stencilName && assetSpaces && propertyName === 'title') {
        const isMovingImageStencil = movingImagesStencils.includes(stencilName);
        return !isMovingImageStencil || assetSpaces.includes('redbull-racing');
    }
    return true;
};
exports.isPropertyTranslatedByAi = isPropertyTranslatedByAi;
exports.targetLanguageCodeMapping = new Map([
    ['en-AU', 'en-GB'],
    ['en-CA', 'en-GB'],
    ['en-CAR', 'en-GB'],
    ['en-IE', 'en-GB'],
    ['en-IN', 'en-GB'],
    ['en-KE', 'en-GB'],
    ['en-MEA', 'en-US'],
    ['en-MK', 'en-GB'],
    ['en-MY', 'en-GB'],
    ['en-NG', 'en-GB'],
    ['en-NZ', 'en-GB'],
    ['en-PH', 'en-US'],
    ['en-PK', 'en-GB'],
    ['en-SE', 'en-GB'],
    ['en-SG', 'en-GB'],
    ['en-ZA', 'en-GB'],
    ['en', 'en-GB'],
]);
const transformToTargetLanguageCode = (targetLangCode) => {
    const mapped = exports.targetLanguageCodeMapping.get(targetLangCode) || targetLangCode;
    const languageCodesWithCountryCode = [
        'en-GB',
        'en-US',
        'pt-BR',
        'pt-PT',
    ];
    const result = languageCodesWithCountryCode.includes(mapped) ? mapped : (0, language_code_util_1.transformLanguageCodeToLocalizationFamily)(mapped);
    return result;
};
exports.transformToTargetLanguageCode = transformToTargetLanguageCode;
//# sourceMappingURL=data:application/json;base64,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